<template>
  <CustomRow>
    <v-card class="mt-5 cusPadding text-center">
      <h3>{{ $t('change_email_title') }}</h3>
      <v-form v-model="isFormValid">
        <v-row class="mt-12">
          <v-spacer />
          <v-col cols="10" sm="8" md="4">
            <v-text-field v-model="email" outlined :label="$t('change_email_new_email_field')"
              :rules="[inputRules.required, inputRules.email]" hint="如：email@example.com" color="primary-1">
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-text-field>
            <div class="v-alert p-4 text-left red--text pink-1">
              {{ $t('change_email_note') }}
            </div>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10" sm="8" md="4">
            <v-btn depressed x-large width="250" class="nextBtn mx-auto"
              :class="{ disabledBtn: !isFormValid || !loadingUpdateFinshed }"
              :disabled="!isFormValid || !loadingUpdateFinshed" color="white" block @click="updateEmail">
              <template v-if="!loadingUpdateFinshed">
                <v-progress-circular indeterminate color="white" size="25" width="2"></v-progress-circular>
              </template>
              <template v-else>
                {{ $t('change_email_cta') }}
              </template>
            </v-btn>
          </v-col>
          <v-spacer />
        </v-row>
      </v-form>
    </v-card>
  </CustomRow>
</template>

<script>
import inputRulesJS from "@/shared/inputRules.js";
import UM from "@/api/user-management";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isFormValid: false,
      email: "",
      inputRules: {
        required: inputRulesJS.required,
        email: inputRulesJS.email
      },
      loadingUpdateFinshed: true
    };
  },
  metaInfo() {
    return {
      title: `${this.$t('change_email_title')} - ${this.$t('app_name')}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('change_email_title')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`更換電子郵件`, this.$route.path);
    }, 200);
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      setLogin: "user/login"
    }),
    async updateEmail() {
      this.loadingUpdateFinshed = false;
      const { data } = await UM.updateUserInfo({ email: this.email });
      if (data.errCode == "00") {
        let userData = this.$store.state.user;
        userData.verifyEmail = false;
        this.setLogin(userData);
        this.$router.push({
          name: "HasSendEmail",
          params: { email: this.email }
        }).catch(() => { });
      }
      if (data.errCode !== "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('change_email_submit_fail')}</div>
          </div>`
        });
      }
      this.loadingUpdateFinshed = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 100px 0;
}
</style>
